import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { 
  ArrowLeft, 
  ExternalLink, 
  Clock, 
  User,
  Rss
} from 'lucide-react';
import Card from '../../components/UI/Card';
import Button from '../../components/UI/Button';
import './Feeds.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const FeedDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/feeds/items/${id}`);
        if (!res.ok) {
          navigate('/feeds');
          return;
        }
        const data = await res.json();
        setItem(data);
        
        // Mark as read
        if (!data.read) {
          await fetch(`${API_BASE}/api/feeds/items/${id}/read`, { method: 'PATCH' });
        }
      } catch (error) {
        console.error('Error fetching feed item:', error);
        navigate('/feeds');
      }
      setLoading(false);
    };

    fetchItem();
  }, [id, navigate]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getSourceIcon = (type) => {
    switch (type) {
      case 'rss': return <Rss size={16} />;
      default: return <Rss size={16} />;
    }
  };

  if (loading) {
    return (
      <div className="loading-state">
        <div className="loading-spinner" />
        <p>加载中...</p>
      </div>
    );
  }

  if (!item) {
    return null;
  }

  return (
    <div className="feed-detail-page">
      <div className="page-header">
        <Button variant="secondary" onClick={() => navigate('/feeds')}>
          <ArrowLeft size={18} />
          返回列表
        </Button>
      </div>

      <Card className="feed-detail-card">
        <div className="feed-detail-header">
          <div className="feed-detail-meta">
            <div className="feed-source-badge">
              {getSourceIcon(item.source?.type)}
              <span>{item.source?.name || '未知来源'}</span>
            </div>
            <div className="feed-detail-time">
              <Clock size={14} />
              {formatDate(item.published_at)}
            </div>
            {item.author && (
              <div className="feed-detail-author">
                <User size={14} />
                {item.author}
              </div>
            )}
          </div>
          
          <a 
            href={item.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="view-original-btn"
          >
            <ExternalLink size={16} />
            查看原文
          </a>
        </div>

        <h1 className="feed-detail-title">{item.title}</h1>

        {item.summary && (
          <div className="feed-detail-summary">
            <h3>AI 摘要</h3>
            <p>{item.summary}</p>
          </div>
        )}

        <div className="feed-detail-content">
          <h3>原文内容</h3>
          <div className="content-body">
            {item.content ? (
              <p>{item.content}</p>
            ) : (
              <p className="no-content">
                原文内容未能获取，请
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  点击查看原文
                </a>
              </p>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FeedDetail;
